/**
 * Mixin xử lý validate combobox
 */
import i18n from '@/i18ns/i18n.js'
import i18nValidate from '@/i18ns/vi/i18nValidate'
import { MSConstant } from '@/commons/wildcards/index.js'

export const validateCombobox = {
  /**
   * @description Xử lý validate rule
   * @param {*} rule
   * @param {*} editor
   * @returns
   */
  validateRule (rule, editor) {
    const me = this
    const $t = i18n.global.t
    const ValidateRule = MSConstant.ValidateRule
    const titleError = editor.getTitleError()
    let isValid = true

    switch (rule) {
      case ValidateRule.ForceSelection:
        isValid = me.validateForceSelection(editor)
        break
      case ValidateRule.NotSelectParent:
        isValid = me.validateNotSelectParent(editor)
        break
      case ValidateRule.Required: {
        const controlValue = editor.getValue()
        isValid = !(controlValue === undefined ||
          controlValue === null ||
          Number.isNaN(controlValue) ||
          controlValue === '')
        break
      }
    }

    return isValid ? '' : i18nValidate.messages[rule](titleError)
  },

  /**
   * Xử lý force selection
   * @param {*} editor
   * @returns
   * HTHIEP 01.07.2022: Sửa lại việc lấy item theo text => case thêm trường hợp có suffix
   */
  validateForceSelection (editor) {
    const me = this

    if (editor?.internalText) {
      // nếu là binding trên grid
      if (
        editor.$cell &&
        editor.queryMode === 'remote' &&
        !editor.lastRequestParam
      ) {
        return true
      }

      const dataSource = editor.internalDataSource

      // nếu là binding thì trả về true
      // pvduy 29/06/2021: sửa lỗi khi hủy form thêm mới trên combobox thì ko cảnh báo.
      if (
        editor.internalText === editor.initText &&
        dataSource.length === 0 &&
        (!me.forceSelection || me.internalValue)
      ) {
        return true
      }

      if (dataSource?.length) {
        if (editor.value) {
          return true
        }
        const valueText = editor.internalText
        const items = editor.findItemByText(valueText)

        return items?.length
      } else {
        return false
      }
    }
    return true
  },

  /**
   * ĐVThi 05/02/2020: Validate bắt buộc chọn con, không được chọn cha
   */
  validateNotSelectParent (editor) {
    return !editor?.internalSelectedItem?.isParent
  },
}
